import Dialog from './Dialog';

const EnterSuccessDialog = ({ onClose }: { onClose: () => void }) => {
  return (
    <Dialog
      title="Enter room request sent"
      onClose={() => onClose()}
      showFooter={false}
    >
      <div style={{ textAlign: 'center' }}>
        If you are already inside Habbo X, it will move you automatically.
        Otherwise please login <a href="https://www.habbox.game/">here</a> in to
        Habbo X.
      </div>
    </Dialog>
  );
};

export default EnterSuccessDialog;
